import {createSlice} from '@reduxjs/toolkit';

const initialPageState = {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0,
    sort: "createdAt",
    desc: true,
};
const initialState = {
    pages: {},
    init:{page: 0,
        size: 10,
        totalElements: 0,
        totalPages: 0,
        sort: "createdAt",
        desc: true,}
};
const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        setPage(state, action) {
            const { keys, totalElements, totalPages, number, size, sort, desc } = action.payload;
            if (!state.pages[keys]) {
                state.pages[keys] = { ...initialPageState };
            }
            state.pages[keys] = {
                ...state.pages[keys],
                totalElements: totalElements ?? state.pages[keys].totalElements ,
                totalPages: totalPages ?? state.pages[keys].totalPages  ,
                page: number ?? state.pages[keys].page,
                size: size ?? state.pages[keys].size,
                sort: sort ?? state.pages[keys].sort,
                desc: desc ?? state.pages[keys].desc,
            };
        },
        movePage(state, action) {
            const { keys, page } = action.payload;
            if (state.pages[keys]) {
                state.pages[keys].page = page;
            }
        },

        changeSize(state, action) {
            const { keys, size } = action.payload;
            if (state.pages[keys]) {
                state.pages[keys].size = size;
            }
        },
        sort(state, action){
            const { keys, sort, desc } = action.payload;
            if (state.pages[keys]) {
                state.pages[keys].sort = sort;
                state.pages[keys].desc = desc;
            }
        },
        cleaPage(state, action) {
            const { keys } = action.payload;
            if (state.pages[keys]) {
                state.pages[keys] = { ...initialPageState };
            }
        },

    },
});

export const getPage = (state) => {
    const keys = state.search.keys;
    return state.page.pages[keys] ?? initialPageState;
};


export const {initPage,  setPage, cleaPage, movePage, sort, changeSize } = pageSlice.actions;

export default pageSlice.reducer;
